/**
 * Timeseries Data Download — Shared Zod schemas
 *
 * Input validation schemas for the oRPC timeseries download endpoint.
 * Used by both the contract (for input spec) and the service (for validation).
 */
import { z } from "zod";
import { uuidSchema } from "./validation-common.js";
import { GranularitySchema, SeriesTypeSchema } from "./timeseries.js";
// ===== ENUMS =====
export const DataTypeSchema = z.enum(["observation", "raw", "forecast"]);
export const TimeseriesModelTypeSchema = z.enum(["seasonal_naive", "arima"]);
// ===== INPUT SCHEMA =====
/**
 * Input schema for GET /timeseries/download
 *
 * Validation rules:
 * - granularity is required for observation/forecast, not for raw
 * - modelType is optional and only meaningful for forecast dataType
 * - startDate must be before endDate (validated in service layer)
 */
export const TimeseriesDownloadInputSchema = z
    .object({
    locationId: uuidSchema,
    seriesType: SeriesTypeSchema,
    dataType: DataTypeSchema,
    granularity: GranularitySchema.optional(),
    startDate: z.iso.datetime(),
    endDate: z.iso.datetime(),
    modelType: TimeseriesModelTypeSchema.optional(),
})
    .superRefine((data, ctx) => {
    // granularity required for observation and forecast
    if ((data.dataType === "observation" || data.dataType === "forecast") &&
        data.granularity === undefined) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["granularity"],
            message: `granularity is required for dataType "${data.dataType}"`,
        });
    }
});
